import React, { useState, useEffect } from "react";
import PerfBaseV2 from "./PerfBasev2";
import { API } from "../MyApi";
import { styled } from "@mui/system";
import { Grid, Modal, TextField, Box, ThemeProvider } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import { Button } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import Checkbox from "@mui/material/Checkbox";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";

const FormContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  width: "50%", // Adjust the width as needed
  margin: "auto",
});

const Form = styled("form")({
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
});

const Home = (props) => {
  const navigate = useNavigate();

  const [v1open, setV1Open] = useState(false);
  const [redirectlink, setRedirectlink] = useState("/");
  const [chillerAge, setChillerAge] = useState("");
  const [country, setCountry] = useState("KSA");
  const [siteLocation, setSiteLocation] = useState("Riyadh");
  const [productFamilies, setProductFamilies] = useState("30XA");
  const [chillersData, setChillersData] = useState({});
  const [productFamiliesData, setProductFamiliesData] = useState(["30XA"]);
  const [productsize, setProductsize] = useState("-");
  const [productsizedata, setProductsizedata] = useState(["-"]);
  const [baseType, setBaseType] = useState("corrbase");
  const [modelNumber, setModelNumber] = useState("");
  const [chillerSerialNum, setChillerSerialNum] = useState("");
  const [siteName, setSiteName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [open, setOpen] = React.useState(false);
  const [chillererror, setChillererror] = React.useState(false);
  const [evapChecked, setEvapChecked] = React.useState(false);

  // PERF BASE
  const [electricPrice, setElectricPrice] = useState("");
  const [buildingType, setBuildingType] = useState("Hospitals");
  const [manfbuildingType, setManfbuildingType] = useState(
    "Commercial (Office / Shopping Mall)"
  );
  const [AnnualPerfDgrade, setAnnualPerfDgrade] = useState("1.00");
  const [buildingloadperc, setBuildingloadperc] = useState("80.0");
  const [designedCapacity, setDesignedCapacity] = useState("");
  const [designedCapacityUnits, setDesignedCapacityUnits] = useState("kW");
  const [designedCOP, setDesignedCOP] = useState("");
  const [currency, setCurrency] = useState("SAR");
  const [manfSource, setManfSource] = useState("EMEA");
  const [powerSupply, setPowerSupply] = useState("60Hz");
  const [investment, setInvestment] = useState("");
  const [fullChillerCode, setFullChillerCode] = useState("");
  const [refleakservcost, setRefleakservcost] = React.useState(6000);
  const [eleccosterror, setEleccosterror] = React.useState(false);

  const [investerror, setInvesterror] = React.useState(false);
  const [chillercaperror, setChillercaperror] = React.useState(false);
  const [evapTdbMinData, setEvapTdbMinData] = React.useState(23.0);
  const [evapRHMaxData, setEvapRHMaxData] = React.useState(80.0);
  const [evapCondPumpPower, setEvapCondPumpPower] = React.useState(0);
  const [evapCondFanPower, setEvapCondFanPower] = React.useState(0);
  const [refLeakFreqency10_15, setRefLeakFreqency10_15] = useState(36);
  const [refLeakFreqency15_20, setRefLeakFreqency15_20] = useState(24);
  const [refLeakFreqency20, setRefLeakFreqency20] = useState(12);
  const [evapCondOperatingMonths, setEvapCondOperatingMonths] = React.useState([
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ]);

  // CORR BASE
  const [distanceToPollution, setDistanceToPollution] = useState("");
  const [distanceToCoast, setDistanceToCoast] = useState(""); // Default to kms
  const [annualAveragedT, setAnnualAveragedT] = useState("");
  const [annualAveragedRH, setAnnualAveragedRH] = useState("");
  const [evaporativeCooling, setEvaporativeCooling] = useState(false);

  // const [corrosionData, setCorrosionData] = React.useState({});

  // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=   CONSOLE LOG   -=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

  // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=   APIS START  -=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-

  useEffect(() => {
    getFamily();
  }, []);

  useEffect(() => {
    get_csns_with_family();
  }, [productFamilies]);

  useEffect(() => {
    getSizeWithFamily();
  }, [productFamilies, manfSource, powerSupply]);

  // useEffect(() => {
  //     generate_surrogate_file();
  // }, [siteLocation, buildingType, buildingloadperc, manfbuildingType]);

  props.setCorrosionData(null);
  props.setBuidingInfoTable(null);
  props.setBuidingInfoTableHR(null);
  props.setBuidingInfoTableWeigh(null);
  props.setBuidingInfoTableTemp(null);

  const getValuesWithSiteLocation = async () => {
    console.log("siteLocation has changed:", siteLocation);
    setOpen(true);
    const param = {
      location: siteLocation,
    };
    if (siteLocation.length > 2) {
      const trh_data = await API.getData("/get_trh", param);
      console.log("T/RH Info", trh_data);
      if (trh_data) {
        setDistanceToCoast(trh_data.data.dist_m);
        setAnnualAveragedT(trh_data.data.TempC);
        setAnnualAveragedRH(trh_data.data.RH);
      }
    }
    setOpen(false);
  };

  const getSizeWithFamily = async () => {
    console.log("Family has changed:", productFamilies);
    setOpen(true);
    const param = {
      family: productFamilies,
      manfSource: manfSource,
      powerSupply: powerSupply,
    };
    const size_data = await API.getData("/get_familysize", param);
    console.log("FamilySize Info", size_data);
    if (size_data) {
      setProductsizedata(size_data.productsizes);
    }
    setOpen(false);
  };

  const getFamily = async () => {
    console.log("Family is set:");
    setOpen(true);
    const response = await API.getData("/get_families", {});
    if (response) {
      setProductFamiliesData(response.families);
    }
    setOpen(false);
  };

  const get_csns_with_family = async () => {
    console.log("New Family chillers fetching..");
    setOpen(true);
    const response = await API.postData("/get_csns_with_family", {
      familyType: productFamilies,
    });
    if (response) {
      setChillersData(response);
    }
    setOpen(false);
  };

  const handleClose = () => setV1Open(false);

  const handleRedirect = () => {
    navigate("/");
  };

  useEffect(() => {
    if (chillerAge === "" || electricPrice === "" || investment === "") {
      setRedirectlink("/version2");
    } else {
      setRedirectlink("/version2outputs");
    }
  }, [chillerAge, electricPrice, investment]);

  const callBackendApi = (params) => {
    if (chillerAge == "" || electricPrice == "" || investment == "") {
      console.log(
        "chillerAge",
        chillerAge,
        "electricPrice",
        electricPrice,
        "investment",
        investment
      );
      if (chillerAge == "") {
        setChillererror(true);
      }
      if (electricPrice == "") {
        setEleccosterror(true);
      }
      if (investment == "") {
        setInvesterror(true);
      }
    } else {
      if (params.includes("estimate_corrosion_init")) {
        estimateCorrosionDataApi();
      }
    }
  };

  const estimateCorrosionDataApi = async () => {
    console.log("estimateCorrosionDataApi called");

    const param = {
      chillerfamily: productFamilies,
      chiller_age: chillerAge,
      evap_cool: evaporativeCooling,
      location: siteLocation,
      country: country,
      investment: investment,
      electricPrice: electricPrice,
      currency: currency,
      powerSupply: powerSupply,
      productsize: productsize,
      modelNumber: modelNumber,
      manfSource: manfSource,
      refLeakServCost: refleakservcost,
      refLeakFreqency10_15: refLeakFreqency10_15,
      refLeakFreqency15_20: refLeakFreqency15_20,
      refLeakFreqency20: refLeakFreqency20,
      chillerSerialNum: chillerSerialNum,
      siteName: siteName,
      customerName: customerName,
      evapCond: evapChecked,
      evapCondTdbMin: evapTdbMinData,
      evapCondRHMax: evapRHMaxData,
      evapCondPumpPower: evapCondPumpPower,
      evapCondFanPower: evapCondFanPower,
    };
    console.log("estimateCorrosionDataApi", param);
    try {
      const unit_info = await API.postData(
        "/estimate_corrosion_data_v2",
        param
      );
      console.log("final Result data", unit_info);
      if (unit_info) {
        const flag = unit_info?.data?.resultdata.date_info;
        if (flag === true) {
          console.log("AC Data is less than 1 year, opening V1 modal", flag);
          setV1Open(true);
          console.log("V1 Opened", v1open);
        }
        props.setCorrosionData(unit_info.data.resultdata);
      }
    } catch (error) {
      console.error("API Error:", error);
      console.log("Error in API call for CCRA V2",error);
      alert("Unexpected Backend Failure\nDetails: " + error?.response?.data?.details || error.message);
      navigate("/version2");
    }
  };

  // =-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=   APIS END   =-=-=-=-=-=-=-=-=-=-=-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=--
  const handleChange = (e) => {
    const { id, value } = e.target;
    switch (id) {
      case "chillerAge":
        setChillerAge(value);
        setChillererror(false);
        break;
      case "productFamilies":
        setProductFamilies(value);
        break;

      default:
        break;
    }
  };

  const handleFamilyChange = (event) => {
    setProductFamilies(event.target.value);
    setProductsize("-");
  };

  const SmallLabel = styled("span")({
    fontSize: "0.85rem", // Adjust the font size as needed
    fontWeight: "bold", // You can adjust other styles here as well
  });

  const handleTypeChange = (value) => {
    setBaseType(value);
    console.log(baseType);
  };

  const countriesData = {
    KSA: ["Riyadh", "Jeddah", "Dammam"],
    UAE: ["Dubai", "Abu Dhabi"],
    Kuwait: ["Kuwait City"],
    Qatar: ["Doha"],
    // UK:['London', 'Cambridge'],
    // Spain:['Tarragona', 'Derio','Sierra-de-cadix'],
    // Germany:['Tubingen', 'Sinshelm', 'Kuppenheim']
  };

  const manfData = {
    EMEA: "50Hz",
    US: "60Hz",
  };

  const powerSupplyData = {
    KSA: "60Hz",
    UAE: "50Hz",
    Kuwait: "50Hz",
    Qatar: "50Hz",
  };

  const designedCapacityUnitsData = {
    kW: "kW",
    RT: "RT",
  };

  const currencyData = {
    KSA: "SAR",
    UAE: "AED",
    Kuwait: "KWD",
    Qatar: "QAR",
    UK: "GBP",
    Spain: "EUR",
    Germany: "EUR",
  };

  const currencySymbols = {
    KSA: "﷼", // Saudi Riyal (SAR)
    UAE: "د.إ", // UAE Dirham (AED)
    Kuwait: "د.ك", // Kuwaiti Dinar (KWD)
    Qatar: "ر.ق", // Qatari Riyal (QAR)
    UK: "£", // British Pound (GBP)
    Spain: "€", // Euro (EUR)
    Germany: "€", // Euro (EUR)
  };

  const handleChangeCountry = (event) => {
    setCountry(event.target.value);
    setSiteLocation(countriesData[event.target.value][0]); // Reset siteLocation when country changes
    setCurrency(currencyData[event.target.value]);
    setPowerSupply(powerSupplyData[event.target.value]);
  };

  const handleChangeSize = (event) => {
    setProductsize(event.target.value);
  };

  const handleChangeSiteLocation = (event) => {
    setSiteLocation(event.target.value);
  };

  const handleClear = () => {
    setChillerAge("");
    setCountry("");
    setSiteLocation("");
    setProductFamilies("");
    setProductsize("-");
    setElectricPrice("");
    setBuildingType("");
    setAnnualPerfDgrade("1.00");
    setDesignedCapacity("");
    setDesignedCOP("");
    setCurrency("");
    setInvestment("");
    setFullChillerCode("");
    setDistanceToPollution("");
    setDistanceToCoast("");
    setAnnualAveragedT("");
    setAnnualAveragedRH("");
    setEvaporativeCooling(false);
    setModelNumber("");
    setChillerSerialNum("");
    setSiteName("");
    setCustomerName("");
  };

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: "50%",
      },
    },
  };

  const handleCheckBoxChange = (event) => {
    setEvapChecked(event.target.checked);
    console.log("setEvapChecked", evapChecked);
  };

  return (
    <div style={{ bgcolor: "", paddingLeft: "15rem" }}>
      <Modal open={v1open} onClose={handleClose}>
        <div
          style={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "white",
            padding: "40px",
            paddingRight: "6rem",
            paddingLeft: "6rem",
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
          <h2>Data Less Than 1 Year</h2>
          <p>Please use the SO-CLOUD V1 website.</p>
          <Button variant="contained" color="primary" onClick={handleRedirect}>
            Go to V1 Website
          </Button>
        </div>
      </Modal>

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="secondary" />
      </Backdrop>

      <Box
        my={10}
        alignItems="center"
        gap={1}
        p={0}
        sx={{ border: "1px solid grey", marginBottom: "1.2rem" }}
        style={{
          marginRight: "5px",
          flex: "90%",
          boxShadow: "rgb(106 156 218 / 71%) 5px 4px 10px 0px",
          alignItems: "flex",
        }}
      >
        <div style={{ paddingTop: "6rem", padding: "1rem" }}>
          <Grid style={{ paddingBottom: "0.8rem" }} container spacing={2}>
            <Tooltip
              title={
                <React.Fragment>
                  <div>Name of Chiller Product Family</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid style={{ paddingTop: 8 }} item xs={12} sm={4}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 100 }}>
                  <InputLabel
                    style={{ marginBottom: 10 }}
                    id="demo-simple-select-helper-label"
                  >
                    <SmallLabel>Product Family</SmallLabel>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={productFamilies}
                    label="Product Familiy"
                    onChange={handleFamilyChange}
                  >
                    {productFamiliesData &&
                      productFamiliesData?.map((family) => (
                        <MenuItem value={family}>
                          <SmallLabel>{family}</SmallLabel>
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>
            </Tooltip>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Service years after Chiller was manufactured</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid style={{ paddingLeft: "3.5rem" }} item xs={12} sm={4}>
                <TextField
                  id="chillerAge"
                  label={<SmallLabel>Chiller Age</SmallLabel>}
                  variant="outlined"
                  fullWidth
                  inputProps={{ min: 0 }}
                  type="number"
                  value={chillerAge}
                  onChange={handleChange}
                  error={chillererror}
                  helperText={
                    chillererror ? "Please enter the chiller age." : ""
                  }
                />
              </Grid>
            </Tooltip>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Chiller unit size</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid
                style={{ paddingLeft: "3rem", paddingTop: 8 }}
                item
                xs={12}
                sm={4}
              >
                <FormControl fullWidth sx={{ m: 1, minWidth: 100 }}>
                  <InputLabel
                    style={{ marginBottom: 10 }}
                    id="demo-simple-select-helper-label"
                  >
                    <SmallLabel>Unit Size</SmallLabel>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={productsize}
                    label="Size"
                    onChange={handleChangeSize}
                    MenuProps={menuProps}
                  >
                    <MenuItem key={"-"} value={"-"}>
                      <SmallLabel>{"-"}</SmallLabel>
                    </MenuItem>
                    {productsizedata.map((size) => (
                      <MenuItem key={size} value={size}>
                        <SmallLabel>{size}</SmallLabel>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Tooltip>
          </Grid>
          <Grid style={{ paddingBottom: "0.8rem" }} container spacing={2}>
            <Tooltip
              title={
                <React.Fragment>
                  <div>Country where Chiller is located at</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid style={{ paddingTop: 8 }} item xs={12} sm={4}>
                <FormControl fullWidth sx={{ m: 1, minWidth: 100 }}>
                  <InputLabel
                    style={{ marginBottom: 10 }}
                    id="demo-simple-select-helper-label"
                  >
                    <SmallLabel>Country</SmallLabel>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={country}
                    label="Product Familiy"
                    onChange={handleChangeCountry}
                  >
                    {Object.keys(countriesData).map((countryKey) => (
                      <MenuItem key={countryKey} value={countryKey}>
                        <SmallLabel>{countryKey}</SmallLabel>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Tooltip>

            <Tooltip
              title={
                <React.Fragment>
                  <div>Location of chiller plant site</div>
                </React.Fragment>
              }
              placement="bottom-end"
              arrow
            >
              <Grid style={{ paddingLeft: "3.5rem" }} item xs={12} sm={4}>
                <TextField
                  id="siteLocation"
                  label={<SmallLabel>Site Location</SmallLabel>}
                  variant="outlined"
                  fullWidth
                  select
                  value={siteLocation}
                  onChange={handleChangeSiteLocation}
                  disabled={!country}
                >
                  {country &&
                    countriesData[country].map((loc) => (
                      <MenuItem key={loc} value={loc}>
                        <SmallLabel>{loc}</SmallLabel>
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            </Tooltip>
            <Grid style={{ paddingLeft: "3.5rem" }} item xs={12} sm={4}>
              <div
                style={{
                  padding: "0.4rem",
                  border: "1px solid #c0c0c0",
                  borderRadius: "5px",
                  marginRight: 8,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Checkbox
                  id="checkbox"
                  checked={evapChecked}
                  variant="outlined"
                  onChange={handleCheckBoxChange}
                />
                <label htmlFor="checkbox">Evaporative Condenser</label>
              </div>
            </Grid>
          </Grid>
        </div>
      </Box>

      <>
        <Box
          my={5}
          alignItems="center"
          gap={1}
          p={2}
          sx={{
            border: "1px solid grey",
            marginBottom: "1.2rem",
            marginTop: "1.2rem",
            boxShadow: "rgb(106 156 218 / 71%) 5px 4px 10px 0px",
          }}
        >
          <PerfBaseV2
            electricPrice={electricPrice}
            setElectricPrice={setElectricPrice}
            buildingType={buildingType}
            setBuildingType={setBuildingType}
            manfbuildingType={manfbuildingType}
            setManfbuildingType={setManfbuildingType}
            AnnualPerfDgrade={AnnualPerfDgrade}
            buildingloadperc={buildingloadperc}
            setBuildingloadperc={setBuildingloadperc}
            setAnnualPerfDgrade={setAnnualPerfDgrade}
            designedCapacity={designedCapacity}
            setDesignedCapacity={setDesignedCapacity}
            designedCapacityUnits={designedCapacityUnits}
            setDesignedCapacityUnits={setDesignedCapacityUnits}
            designedCOP={designedCOP}
            setDesignedCOP={setDesignedCOP}
            currency={currency}
            setCurrency={setCurrency}
            investment={investment}
            chillersData={chillersData}
            setInvestment={setInvestment}
            fullChillerCode={fullChillerCode}
            setFullChillerCode={setFullChillerCode}
            eleccosterror={eleccosterror}
            investerror={investerror}
            chillercaperror={chillercaperror}
            setEleccosterror={setEleccosterror}
            setInvesterror={setInvesterror}
            setChillercaperror={setChillercaperror}
            modelNumber={modelNumber}
            setModelNumber={setModelNumber}
            chillerSerialNum={chillerSerialNum}
            setChillerSerialNum={setChillerSerialNum}
            siteName={siteName}
            setSiteName={setSiteName}
            customerName={customerName}
            setCustomerName={setCustomerName}
            evapChecked={evapChecked}
            refLeakFreqency10_15={refLeakFreqency10_15}
            setRefLeakFreqency10_15={setRefLeakFreqency10_15}
            refLeakFreqency15_20={refLeakFreqency15_20}
            setRefLeakFreqency15_20={setRefLeakFreqency15_20}
            refLeakFreqency20={refLeakFreqency20}
            setRefLeakFreqency20={setRefLeakFreqency20}
            setRefleakservcost={setRefleakservcost}
            refleakservcost={refleakservcost}
            setChillerAge={setChillerAge}
            manfSource={manfSource}
            setManfSource={setManfSource}
            powerSupply={powerSupply}
            setPowerSupply={setPowerSupply}
            manfData={manfData}
            evapTdbMinData={evapTdbMinData}
            evapRHmaxData={evapRHMaxData}
            setEvapTdbMinData={setEvapTdbMinData}
            setEvapRHMaxData={setEvapRHMaxData}
            evapCondPumpPower={evapCondPumpPower}
            setEvapCondPumpPower={setEvapCondPumpPower}
            evapCondFanPower={evapCondFanPower}
            setEvapCondFanPower={setEvapCondFanPower}
            evapCondOperatingMonths={evapCondOperatingMonths}
            setEvapCondOperatingMonths={setEvapCondOperatingMonths}
          ></PerfBaseV2>
        </Box>
      </>

      <Grid
        style={{ marginTop: "3rem", justifyContent: "center" }}
        container
        spacing={2}
      >
        <Grid style={{ paddingTop: 8 }} item xs={12} sm={2}>
          <Button
            size="large"
            component={Link}
            to={redirectlink}
            onClick={() => callBackendApi(["estimate_corrosion_init"])}
            fullWidth
            variant="contained"
          >
            Submit
          </Button>
        </Grid>
        <Grid style={{ paddingTop: 8 }} item xs={12} sm={2}>
          <Button
            size="large"
            color="error"
            onClick={() => handleClear()}
            fullWidth
            variant="contained"
          >
            Clear All
          </Button>
        </Grid>
      </Grid>

      <div style={{ marginBottom: "2rem" }}></div>
    </div>
  );
};

export default Home;
